<template>
  <el-form
    ref="ruleFormRef"
    v-loading="loading"
    :model="ruleForm"
    :rules="rules"
    class="demo-ruleForm"
    size="large"
    status-icon
  >
    <el-form-item label="类别名称" prop="name">
      <el-input
        v-model="ruleForm.name"
        placeholder="请填写类别名称"
        class="middle_input"
      />
    </el-form-item>
    <el-form-item label="类别图片" prop="imgUrl">
      <ImgUpload
        v-if="childShow"
        :type="3"
        :limit="1"
        ref="addEditImgRef"
        :imagePath="ruleForm.imgUrl"
        @change-image="changeImage"
      ></ImgUpload>
    </el-form-item>
    <el-form-item
      label="是否普通专升本专业类别"
      prop="isPtzsb"
      class="customize_width"
    >
      <el-switch
        v-model="ruleForm.isPtzsb"
        class="mb-2"
        active-text="是"
        inactive-text="否"
      />
    </el-form-item>
  </el-form>
  <div slot="footer" class="from_btn">
    <el-button @click="resetForm" size="large">取消</el-button>
    <el-button v-if="!submitDisabled" type="primary" size="large" @click="submitForm(ruleFormRef)"
       :disabled = "submitDisabled">提交保存</el-button
    >
    <el-button type="primary" size="large" loading v-else>提交中</el-button>
  </div>
</template>

<script>
import {
  getMajorCategoryDetail,
  createMajorCategory,
  updateMajorCategory,
} from "network/majorCategory.js";
import ImgUpload from "components/ImgUpload.vue";
import { toRefs, reactive, ref, unref, onMounted } from "vue";
import { ElMessage, ElMessageBox } from "element-plus";

export default {
  name: "AddEditMajorCategory",
  components: {
    ImgUpload,
  },
  emits: {
    "close-dialog": null,
    "update-list": null,
  },
  props: {
    editId: Number,
  },
  setup(props, { emit }) {
    const ruleFormRef = ref();
    const addEditImgRef = ref();
    const data = reactive({
      loading: false,
      childShow: false, //避免编辑传递数据过慢，子组件拿不到
      ruleForm: {
        name: "",
        imgUrl: "",
        isPtzsb: null,
      },
      rules: {
        name: [
          {
            required: true,
            message: "请填写类别名称",
            trigger: "blur",
          },
        ],
        imgUrl: [
          {
            required: true,
            message: "请选择类别图片",
            trigger: "blur",
          },
        ],
        isPtzsb: [
          {
            required: true,
            message: "是否普通专升本专业类别",
            trigger: "blur",
          },
        ],
      },
      submitDisabled:false,
    });

    //编辑  请求专业类别详情
    if (props.editId > 0) {
      data.loading = true;
      getMajorCategoryDetail(props.editId)
        .then((result) => {
          if (result && result.code == 1) {
            data.childShow = true;
            data.loading = false;
            data.ruleForm = result.result;
          } else {
            data.loading = false;
            ElMessage.error(result.message);
          }
        })
        .catch((err) => {
          data.loading = false;
          console.log(err);
        });
    } else {
      data.childShow = true;
    }
    //获取图片上传组件传过来的
    const changeImage = (arr) => {
      if (arr && arr.length > 0) {
        data.ruleForm.imgUrl = arr[0].url;
        ruleFormRef.value.clearValidate("imgUrl");
      } else {
        data.ruleForm.imgUrl = "";
      }
    };

    // 提交
    const submitForm = async () => {
      const form = unref(ruleFormRef);
      if (!form) return;
      try {
        const valid = await form.validate();
        if (!valid) {
          return false;
        } else {
          data.submitDisabled = true;
          updataAdd(data.ruleForm).then(() => {
            data.submitDisabled = false;
          });
        }
      } catch (error) {
        console.log(error);
      }
    };
    async function updataAdd(data) {
      data.loading = true;
      let result = "";
      if (props.editId > 0) {
        const editdata = {
          id: data.id,
          name: data.name,
          imgUrl: data.imgUrl,
          isPtzsb: data.isPtzsb,
        };
        result = await updateMajorCategory(editdata);
      } else {
        result = await createMajorCategory(data);
      }
      if (result && result.code == 1) {
        data.loading = false;
        ElMessageBox.alert(result.message, props.editId > 0 ? "编辑" : "添加", {
          confirmButtonText: "确定",
        });
        if (addEditImgRef.value) {
          if (props.editId > 0) {
            const editdata = {
              id: data.id,
              name: data.name,
              imgUrl: data.imgUrl,
              isPtzsb: data.isPtzsb,
            };
            addEditImgRef.value.submitData(editdata.imgUrl);
          } else {
            addEditImgRef.value.submitData(data.imgUrl);
          }
        }
        emit("close-dialog");
        emit("update-list");
      } else {
        data.loading = false;
        ElMessageBox.alert(result.message, props.editId > 0 ? "编辑" : "添加", {
          confirmButtonText: "确定",
                  });
      }
    }
    onMounted(() => {});
    // 取消操作  关闭弹窗
    const resetForm = () => {
      emit("close-dialog");
      ruleFormRef.value.resetFields();
      // 关闭弹窗 判断图片删除
      if (addEditImgRef.value) {
        addEditImgRef.value.cancelData();
      }
    };
    return {
      ...toRefs(data),
      ruleFormRef,
      addEditImgRef,
      changeImage,
      submitForm,
      resetForm,
    };
  },
};
</script>
<style scoped>
.customize_width el-form-item__label {
  width: 190px !important;
}
</style>

